import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Text,
  Tfoot,
  Th,
  Thead,
  Select,
  Link,
  Tr,
  Skeleton,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllBrokers } from "../api";
import { SearchIcon } from "../assets/svgs/Icons";
import { getFarmersList } from "../Components/farmer/FarmerSlice";
import { useDispatch, useSelector } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import ReactPaginate from "react-paginate";
import FarmerTable from "../Components/farmer/FarmerTable";
import {
  Column,
  useReactTable,
  ColumnFiltersState,
  getCoreRowModel,
  getFilteredRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFacetedMinMaxValues,
  getPaginationRowModel,
  sortingFns,
  getSortedRowModel,
  FilterFn,
  SortingFn,
  ColumnDef,
  flexRender,
  FilterFns,
  createColumnHelper,
} from "@tanstack/react-table";
import { rankItem } from "@tanstack/match-sorter-utils";
import withClient from "../routing/withClient";
import isAllowed from "../routing/isAllowed";
import { IoChevronBackCircleSharp } from "react-icons/io5";

function APMC() {
  const [brokers, setBrokers] = useState([]);
  const navigate = useNavigate();
  const [status, setStatus] = useState("idle");
  const [offset, setOffset] = useState(1);
  const [perPage] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");

  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage + 1);
  };

  const getBrokersData = async () => {
    let brokersData = await getAllBrokers("APMC");
    console.log(brokersData)
    setPageCount(brokersData?.totalPages);

    const updatedData = brokersData?.data.map((d, index) => {
      return {
        ...d,
        srNo: index + 1,
        fullName: `${d.firstName} ${d.lastName}`,
        actions: "actions",
      };
    });

    setBrokers(updatedData);
    if (brokersData?.data) {
      setIsLoaded(true);
    }
  };

  const searchItems = () => {
    if (searchInput !== "") {
      const filteredData = brokers.filter((item) => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(searchInput.toLowerCase());
      });
      setFilteredResults(filteredData);
    } else {
      setFilteredResults(brokers);
    }
  };

  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.accessor("srNo", {
      cell: (info) => info.getValue(),
      header: "Sr No.",
    }),
    columnHelper.accessor("name", {
      cell: (info) => info.getValue(),
      header: "Name",
    }),
    columnHelper.accessor("type", {
      cell: (info) => info.getValue(),
      header: "Type",
      // meta: {
      //   isNumeric: true,
      // },
    }),
    columnHelper.accessor("address.raw_address", {
      cell: (info) => info.getValue(),
      header: "Address Details",
      // meta: {
      //   isNumeric: true,
      // },
    }),
    columnHelper.accessor("actions", {
      Cell: ({ cell }) => console.log(),
      header: "Actions",
      // meta: {
      //   isNumeric: true,
      // },
    }),
  ];

  const fuzzyFilter = (row, columnId, value, addMeta) => {
    // Rank the item
    const itemRank = rankItem(row.getValue(columnId), value);
    // Store the itemRank info
    addMeta({
      itemRank,
    });
    // Return if the item should be filtered in/out
    return itemRank.passed;
  };

  const table = useReactTable({
    data: brokers,
    columns,
    filterFns: {
      fuzzy: fuzzyFilter,
    },
    state: {
      columnFilters,
      globalFilter,
    },
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: fuzzyFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    // getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    // getFacetedRowModel: getFacetedRowModel(),
    // getFacetedUniqueValues: getFacetedUniqueValues(),
    // getFacetedMinMaxValues: getFacetedMinMaxValues(),
    debugTable: true,
    debugHeaders: true,
    debugColumns: false,
  });

  useEffect(() => {
    searchItems();
  }, []);

  useEffect(() => {
    getBrokersData();
  }, []);

  return (
    <Box paddingTop={"0.5rem"}>
      <Flex gap={"10"} alignItems={"center"}>
        <Box>
          {" "}
          <InputGroup>
            <InputLeftElement
              pointerEvents="none"
              children={<SearchIcon color="#B8DEF8" />}
            />
            <Input
              type="text"
              color={"#464C64"}
              bg={"#fff"}
              w={"280px"}
              h={"48px"}
              value={globalFilter ?? ""}
              placeholder="Search All Results"
              onChange={(e) => setGlobalFilter(e.target.value)}
              fontSize={"14px"}
              borderRadius={"10px"}
              _placeholder={{
                opacity: 1,
                color: "#464C64",
                fontSize: "14px",
              }}
            />
          </InputGroup>
        </Box>
        <Box>
          <Button
            onClick={() => navigate("/supplier/add-supplier")} 
            bg="#52BBFF"
            color={"#fff"}
            _hover={{ bg: "#52BBFF" }}
          >
            Add Supplier
          </Button>
        </Box>
        <Box></Box>
      </Flex>
      <Box marginTop={"2rem"}>
        {/* {searchInput ? (
          <FarmerTable farmersData={filteredResults} isLoaded={isLoaded} />
        ) : ( */}
        <Box display={"flex"} justifyContent="space-between">
          <Box
            as="span"
            display="flex"
            alignItems="center"
            marginBottom={"10px"}
            gap="5px"
          >
            <div>Page</div>
            <strong>
              {table.getState().pagination.pageIndex + 1} of{" "}
              {table.getPageCount()}
            </strong>
          </Box>
          <Box>
            <Box display={"flex"} alignItems="center" marginBottom={"10px"}>
              <Box
                as="span"
                display="flex"
                alignItems="center"
                gap="5px"
                marginRight={"10px"}
              >
                <Box as="span" width={"30%"}>
                  {" "}
                  Go to page:{" "}
                </Box>
                <Input
                  w={"60%"}
                  type="number"
                  color={"#464C64"}
                  bg={"#fff"}
                  defaultValue={table.getState().pagination.pageIndex + 1}
                  onChange={(e) => {
                    const page = e.target.value
                      ? Number(e.target.value) - 1
                      : 0;
                    table.setPageIndex(page);
                  }}
                />
              </Box>
              <Box>
                <Select
                  bg="#fff"
                  value={table.getState().pagination.pageSize}
                  onChange={(e) => {
                    table.setPageSize(Number(e.target.value));
                  }}
                >
                  {[10, 20, 30, 40, 50].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      Show {pageSize}
                    </option>
                  ))}
                </Select>
              </Box>
            </Box>
          </Box>
        </Box>
        {brokers?.length > 0 ? (
          //   <FarmerTable
          //     farmersData={brokers}
          //     columns={columns}
          //     table={table}
          //     isLoaded={isLoaded}
          //   />
          <TableContainer className="overflow-style" overflowX={"scroll"}>
            <Table size="md" bg={"#fff"} borderRadius={"15px"}>
              <Thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <Tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => {
                      // see https://tanstack.com/table/v8/docs/api/core/column-def#meta to type this correctly
                      const meta = header.column.columnDef.meta;
                      return (
                        <Th
                          key={header.id}
                          onClick={header.column.getToggleSortingHandler()}
                          isNumeric={meta?.isNumeric}
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                          {/* 
                  <chakra.span pl="4">
                    {header.column.getIsSorted() ? (
                      header.column.getIsSorted() === "desc" ? (
                        <TriangleDownIcon aria-label="sorted descending" />
                      ) : (
                        <TriangleUpIcon aria-label="sorted ascending" />
                      )
                    ) : null}
                  </chakra.span> */}
                        </Th>
                      );
                    })}
                  </Tr>
                ))}
              </Thead>
              <Tbody>
                {!isLoaded ? (
                  <>
                    <Tr>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                    </Tr>
                    <Tr>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                    </Tr>
                    <Tr>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                    </Tr>
                    <Tr>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                      <Td>
                        <Skeleton height="20px" fadeDuration={1} />
                      </Td>
                    </Tr>
                  </>
                ) : (
                  <>
                    {table.getRowModel()?.rows?.map((row) => (
                      <Tr key={row?.id}>
                        {row.getVisibleCells().map((cell) => {
                          // see https://tanstack.com/table/v8/docs/api/core/column-def#meta to type this correctly
                          const meta = cell?.column?.columnDef?.meta;
                          return (
                            <Td key={cell?.id} isNumeric={meta?.isNumeric}>
                              {cell?.renderValue() === "actions" ? (
                                <Link
                                  color={"#3958DC"}
                                  fontWeight="800"
                                  onClick={() =>
                                    navigate(
                                      `/supplier/supplier-details/${cell?.row.original?._id}`
                                    )
                                  }
                                >
                                  View Details
                                </Link>
                              ) : (
                                flexRender(
                                  cell?.column?.columnDef?.cell,
                                  cell?.getContext()
                                )
                              )}
                            </Td>
                          );
                        })}
                      </Tr>
                    ))}
                  </>
                )}
              </Tbody>
              <Tfoot>
                {/* <Tr>
          <Th>To convert</Th>
          <Th>into</Th>
          <Th isNumeric>multiply by</Th>
        </Tr> */}
              </Tfoot>
            </Table>
          </TableContainer>
        ) : (
          <>
            <Box
              display={"flex"}
              alignItems="center"
              justifyContent="center"
              mt="2rem"
              bg="white"
              borderRadius="15px"
            >
              <Text
                fontSize={"25px"}
                fontWeight={"bold"}
                textAlign="center"
                p="2rem"
              >
                There are no suppliers yet.
              </Text>
            </Box>
          </>
        )}
        <Box
          display={"flex"}
          justifyContent="center"
          marginTop={"1rem"}
          marginBottom="2rem"
        >
          <Box display={"flex"} gap="2rem">
            <Button
              className="border rounded p-1"
              bg="#52BBFF"
              _hover={{ bg: "#52BBFF" }}
              onClick={() => table.previousPage()}
              disabled={!table.getCanPreviousPage()}
            >
              <AiOutlineArrowLeft color="#141D43" size={18} />
            </Button>
            <Button
              className="border rounded p-1"
              bg="#52BBFF"
              _hover={{ bg: "#52BBFF" }}
              onClick={() => table.nextPage()}
              disabled={!table.getCanNextPage()}
            >
              <AiOutlineArrowRight color="#141D43" size={18} />
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default isAllowed(APMC);
